import Omi, { Component, h, tag } from "omi";

import { tailwind } from "@/tailwind";

import styles from "./style.css?inline";

type Props = {
  label: string;
  text: string;
};

@tag("nw-metabox")
export class NWMetabox extends Component {
  static css = [tailwind, styles];

  static propTypes = {
    label: String,
    text: String,
  };

  render(props: Omi.OmiProps<Props>) {
    return (
      <div class="flex items-center gap-3">
        <div
          id=""
          class="flex p-2 h-[32px] w-[32px] justify-center items-center border border-gray-300 rounded-md shadow-xs"
        >
          <slot name="icon" class=""></slot>
        </div>
        <div class="font-semibold text-sm">{props.label}</div>
        <div class="text-sm">{props.text}</div>
      </div>
    );
  }
}
